// react
import styled from 'styled-components';

// components
import { Title, Button } from '@/components/atoms';

export const DeleteAccount = ({}: DeleteAccountProps) => {
  return (
    <Content>
      <Title>Delete account</Title>
      <HelperText>
        If you'd like to delete your account, feel free to get in touch with us
        at &nbsp;
        <Button
          variant='link'
          size='md'
          isInline
          ariaLabel='here'
          to={`mailto://${process.env.REACT_APP_SUPPORT_EMAIL}`}
        >
          {process.env.REACT_APP_SUPPORT_EMAIL}
        </Button>
        .<br /> Don't hesitate to reach out if you have any questions or
        concerns.
        <br /> We're here to help!
      </HelperText>
    </Content>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.spacing[24]};
  margin: ${(props) => props.theme.spacing[24]};
  margin-top: ${(props) => props.theme.spacing[96]};
`;

const HelperText = styled.div`
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[80]};
  text-align: center;
`;

interface DeleteAccountProps {}

DeleteAccount.displayName = 'AccountDelete';

export default DeleteAccount;
